module.exports = __webpack_public_path__ + "static/media/Business accounts - SD (1).427780d7.jpg";